import logger from '../util/logger.js';
// sensor manager: manages sensors group and id map, provides add/remove helpers
export function createSensorManager({ sensors, disposeLabel, externalLogger }) {
	const sensorsById = new Map();
	const log = externalLogger || logger;

	function addSensor(mesh) {
		sensors.add(mesh);
		try {
			const sid = mesh && mesh.userData && mesh.userData._sensorUid ? mesh.userData._sensorUid : (mesh && mesh.userData && mesh.userData.sensor && (mesh.userData.sensor.id || mesh.userData.sensor.label));
			if (sid) {
				sensorsById.set(String(sid), mesh);
				log.debug && log.debug('sensorManager: add', sid);
			}
		} catch (e) { log.warn && log.warn('sensorManager.addSensor failed', e); }
	}

	function removeSensor(sensorOrId) {
		let mesh = null;
		if (typeof sensorOrId === 'string' || typeof sensorOrId === 'number') mesh = sensorsById.get(String(sensorOrId));
		else mesh = sensorOrId;
		if (!mesh) return false;
		try {
			// guard: mark mesh as disposed so event handlers can skip
			try { mesh.__disposed = true; } catch (e) { }
			if (mesh.userData && mesh.userData._labelEl) disposeLabel(mesh.userData._labelEl);
			if (mesh.parent) mesh.parent.remove(mesh);
			if (mesh.geometry) mesh.geometry.dispose();
			if (mesh.material) mesh.material.dispose();
			if (mesh.userData && mesh.userData._sensorUid) sensorsById.delete(String(mesh.userData._sensorUid));
			log.debug && log.debug('sensorManager: remove', mesh.userData && mesh.userData._sensorUid);
			return true;
		} catch (e) { log.warn && log.warn('sensorManager.removeSensor failed', e); return false; }
	}

	function removeAllSensors() {
		const toRemove = sensors.children.slice();
		toRemove.forEach(c => { if (c.isMesh) removeSensor(c); });
	}

	return { addSensor, removeSensor, removeAllSensors, _sensorsById: sensorsById };
}

export default createSensorManager;
